import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import Future_ReadyInfrastructureforCities from '../../../Assets/Images/ProjectsImg/TrainingCertificateCourses/Future_ReadyInfrastructureforCities.jpeg'
import Future_Ready_Infrastructure_for_Cities_TCC1 from '../../../Assets/Images/Training/Certificate cources/Future Ready Infrastructure for Cities/Future_Ready_Infrastructure_for_Cities_TCC1.jpeg';
import Future_Ready_Infrastructure_for_Cities_TCC2 from '../../../Assets/Images/Training/Certificate cources/Future Ready Infrastructure for Cities/Future_Ready_Infrastructure_for_Cities_TCC2.jpeg';
import Future_Ready_Infrastructure_for_Cities_TCC3 from '../../../Assets/Images/Training/Certificate cources/Future Ready Infrastructure for Cities/Future_Ready_Infrastructure_for_Cities_TCC3.jpeg';
import Future_Ready_Infrastructure_for_Cities_TCC4 from '../../../Assets/Images/Training/Certificate cources/Future Ready Infrastructure for Cities/Future_Ready_Infrastructure_for_Cities_TCC4.jpeg';
import Future_Ready_Infrastructure_for_Cities_TCC5 from '../../../Assets/Images/Training/Certificate cources/Future Ready Infrastructure for Cities/Future_Ready_Infrastructure_for_Cities_TCC5.jpeg';

import Future_Ready_Infrastructure_for_Cities_TCC6 from '../../../Assets/Images/Training/Certificate cources/Future Ready Infrastructure for Cities/Future_Ready_Infrastructure_for_Cities_TCC6.jpg';
import Future_Ready_Infrastructure_for_Cities_TCC7 from '../../../Assets/Images/Training/Certificate cources/Future Ready Infrastructure for Cities/Future_Ready_Infrastructure_for_Cities_TCC7.jpg';
import Future_Ready_Infrastructure_for_Cities_TCC8 from '../../../Assets/Images/Training/Certificate cources/Future Ready Infrastructure for Cities/Future_Ready_Infrastructure_for_Cities_TCC8.jpg';

import Final_Concept_Note_FPDP_2024_25 from '../../../Assets/Images/Training/Certificate cources/Future Ready Infrastructure for Cities/Final_Concept_Note_FPDP_2024_25.pdf';
import Programme_Schedule_FPDP_2024_25 from '../../../Assets/Images/Training/Certificate cources/Future Ready Infrastructure for Cities/Programme_Schedule_FPDP_2024_25.pdf';

const Future_Ready_Infrastructure_for_Cities = () => {

    return (
        <div className="mt-5">
            <h4>Future Ready Infrastructure for Cities</h4>

            <div className="card mt-5">
                <img
                    src={Future_ReadyInfrastructureforCities}
                    className="card-img-top"
                    alt="Poster"
                />
            </div>

            <div className="mt-5">
                <p>The Faculty and Professional Development Programme (FPDP) on “Future Ready Infrastructure for Cities” was organized by the Department of Urban Planning at the School of Planning and Architecture, New Delhi. Held from 16th to 20th December 2024 at Swami Vivekananda Sabhagar, the program brought together 31 participants, including faculty members, urban planners, professionals, and scholars. It aimed to equip participants with essential knowledge and skills for creating sustainable, resilient, and technology-integrated urban infrastructure aligned with the vision of “Viksit Bharat.”</p>
                <p>The five-day intensive programme included expert lectures and interactive sessions that addressed critical themes such as data-driven governance, resilient infrastructure, sustainable urbanization, and collaborative planning. Emphasizing human-centric and adaptable solutions, the programme highlighted the need for integrated approaches involving local governments, technology partners, and community participation. Participants were awarded certificates based on attendance and performance, with the program also offering 3 credit points upon successful completion. The FPDP served as a vital platform for professional growth and dialogue, enhancing capacity to develop future-ready cities that are inclusive, livable, and prepared for emerging urban challenges</p>
            </div>


            <div className="row mb-4 mt-5">
                <div className="col-md-4 mb-3">
                    <div className="card">
                        <img src={Future_Ready_Infrastructure_for_Cities_TCC6} className="card-img-top" alt="Event" />
                    </div>
                </div>
                <div className="col-md-4 mb-3">
                    <div className="card">
                        <img src={Future_Ready_Infrastructure_for_Cities_TCC7} className="card-img-top" alt="Event" />
                    </div>
                </div>
                <div className="col-md-4 mb-3">
                    <div className="card">
                        <img src={Future_Ready_Infrastructure_for_Cities_TCC8} className="card-img-top" alt="Event" />
                    </div>
                </div>
            </div>

            <div className="mb-4">
                <p><strong>Concept Note: </strong>
                    <button
                        className="btn btn-outline-primary btn-sm"
                        onClick={() => {
                            window.open(Final_Concept_Note_FPDP_2024_25, '_blank');
                        }}
                    >
                        Open PDF
                    </button>
                </p>
                <p><strong>Programme Schedule: </strong>
                    <button
                        className="btn btn-outline-primary btn-sm"
                        onClick={() => {
                            window.open(Programme_Schedule_FPDP_2024_25, '_blank');
                        }}
                    >
                        Open PDF
                    </button>
                </p>
            </div>

            <div>
                <p><strong>Timeline:</strong> 16 December 2024 - 20 December 2024</p>
                <p><strong>Status:</strong> Completed</p>
            </div>
        </div>
    );
};

export default Future_Ready_Infrastructure_for_Cities;

